export default "__VITE_ASSET__Dkkg9v7d__"